import React from 'react'
import PropTypes from 'prop-types'

const styles = {
    col1: {
        fill: '#28AAE1',
        fillRule: 'nonzero',
    },
}

const factorySettingsSVG = ({ classes, color, width, height }) => (
    <svg viewBox="0 0 47.76 47.911" width={width} height={height}>
        <path
            d=" M 5.972 35.894 L 1.751 38.487 L 1.39 33.301 L 1.028 27.995 L 5.61 30.648 L 10.193 33.241 L 5.972 35.894 Z "
            style={{ fill: color }}/>
        <path
            d=" M 41.788 11.353 L 46.009 8.761 L 46.371 14.006 L 46.732 19.252 L 42.15 16.599 L 37.567 14.006 L 41.788 11.353 Z "
            style={{ fill: color }}/>
        <path
            d=" M 46.009 26.85 C 44.562 37.522 35.457 45.783 24.363 45.783 C 16.223 45.783 9.047 41.26 5.309 34.628"
            fill="none" vectorEffect="nonScalingStroke" strokeWidth="2.999" style={{ stroke: color }}
            strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4"/>
        <path
            d=" M 43.416 13.283 C 39.678 6.65 32.563 2.128 24.363 2.128 C 13.328 2.128 4.163 10.389 2.777 21.061"
            fill="none" vectorEffect="nonScalingStroke" strokeWidth="2.999" style={{ stroke: color }}
            strokeLinejoin="miter" strokeLinecap="butt" strokeMiterlimit="4"/>
        <path
            d=" M 32.261 13.283 L 31.357 26.85 L 24.845 21.061 L 22.312 26.307 L 16.524 21.061 L 13.69 26.85 L 13.69 34.628 L 35.035 34.628 L 35.035 28.779 L 35.035 26.85 L 34.131 13.283 L 32.261 13.283 Z "
            style={styles.col1}/>
    </svg>
)

factorySettingsSVG.defaultProps = {
    color: '#fff',
    width: 24,
    height: 24,
}

factorySettingsSVG.propTypes = {
    color: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
}

export default factorySettingsSVG

